// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vl-functional-header__language-switch {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 1rem;
}
.vl-functional-header__language-switch .locale {
  margin-right: 1rem;
  font-size: 1.4rem;
  font-weight: 500;
}
.vl-functional-header__language-switch .locale a {
  color: #333 !important;
  text-decoration: none;
}
.vl-functional-header__language-switch .locale a:hover {
  color: #05c !important;
}
.vl-functional-header__language-switch .locale .active {
  color: #666 !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
